var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolfCartIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-268 -191)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    transform: "translate(268 191)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.76 193.28)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.297,
    height: 1.438,
    rx: 0.719,
    transform: "translate(0.782 0)",
    fill: "#4f5b6d",
    stroke: "#4f5b6d",
    strokeMiterlimit: 10,
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.794,
    height: 1.438,
    rx: 0.719,
    transform: "translate(8.163 6.279) rotate(-39)",
    fill: "#4f5b6d",
    stroke: "#4f5b6d",
    strokeMiterlimit: 10,
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.976,
    height: 1.438,
    rx: 0.58,
    transform: "translate(10.254 4.927) rotate(50.06)",
    fill: "#4f5b6d",
    stroke: "#4f5b6d",
    strokeMiterlimit: 10,
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.089,
    height: 1.438,
    rx: 0.67,
    transform: "matrix(0.294, 0.956, -0.956, 0.294, 13.188, 0.372)",
    fill: "#4f5b6d",
    stroke: "#4f5b6d",
    strokeMiterlimit: 10,
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.395,
    height: 1.438,
    rx: 0.67,
    transform: "translate(2.949 0.162) rotate(90)",
    fill: "#4f5b6d",
    stroke: "#4f5b6d",
    strokeMiterlimit: 10,
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 2.095,
    r: 2.095,
    transform: "translate(0.162 10.537)",
    fill: "none",
    stroke: "#4f5b6d",
    strokeMiterlimit: 10,
    strokeWidth: 1.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.095,
    cy: 2.095,
    r: 2.095,
    transform: "translate(12.568 10.555)",
    fill: "none",
    stroke: "#4f5b6d",
    strokeMiterlimit: 10,
    strokeWidth: 1.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82,20.55",
    transform: "translate(-5.757 -8.179)",
    fill: "#4f5b6d",
    stroke: "#4f5b6d",
    strokeMiterlimit: 10,
    strokeWidth: 1.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75,19.908V16.825s1.124-1.888,2.149-2l.369-2.409s1.7-2.3,1.9,2.7c0,0,4.288-.117,4.5,2.337h3.9l1.582-2.373a2.275,2.275,0,0,1,2.167,1.5l.351,2.886s0-1.933-2.7-1.753c0,0-2.167.27-2.167,2.167H10.686s-.8-2.248-2.239-2.248C8.447,17.607,5.75,17.688,5.75,19.908Z",
    transform: "translate(-5.75 -7.304)",
    fill: "#4f5b6d",
    stroke: "#4f5b6d",
    strokeMiterlimit: 10,
    strokeWidth: 1.04
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfCartIconDark);
export default __webpack_public_path__ + "static/media/golf-cart-icon-dark.450f6d36c3a1a53e1b16e56cd6e84b78.svg";
export { ForwardRef as ReactComponent };